import React, { useState } from "react";
import { useProfileScreenVM } from "@screens/ProfileScreen/ProfileScreenVM";
import { useLang } from "@src/hooks/useLang";
import { toast } from "react-toastify";
import Layout from "@components/Layout";
import ProfileScreenHeadButtons from "@screens/ProfileScreen/ProfileScreenHeadButtons";
import ProfileScreenForm from "@screens/ProfileScreen/ProfileScreenForm";
import LogoutConfirmDialog from "@screens/ProfileScreen/dialogs/LogoutConfirmDialog";
import ChangePasswordDialog from "@screens/ProfileScreen/dialogs/ChangePasswordDialog";
import { observer } from "mobx-react-lite";

interface IProps {}

const ProfileScreenImpl: React.FC<IProps> = () => {
  const vm = useProfileScreenVM();
  const lang = useLang();
  const [logoutDialogOpened, setLogoutDialogOpened] = useState(false);
  const [changePasswordOpened, setChangePasswordOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    return await vm
        .updateProfileData()
        .then(() => toast(lang.profile.profileSaveSuccess, { type: "success" }))
        .catch((e) => toast(e.message ?? e.toString(), { type: "error" }))
        .finally(() => setLoading(false))
  };

  return (
    <Layout
      title={lang.profile.profileTitle}
      subtitle={lang.profile.profileSubtitle}
      extra={
        <ProfileScreenHeadButtons
          onLogOut={() => setLogoutDialogOpened(true)}
        />
      }
    >
      <ProfileScreenForm
        loading={loading}
        onCancel={vm.resetFormData}
        onSave={handleSave}
        onChangePassword={() => setChangePasswordOpened(true)}
      />
      <LogoutConfirmDialog
        visible={logoutDialogOpened}
        onClose={() => setLogoutDialogOpened(false)}
      />
      <ChangePasswordDialog
        visible={changePasswordOpened}
        onClose={() => setChangePasswordOpened(false)}
      />
    </Layout>
  );
};
export default observer(ProfileScreenImpl);
